import { useTranslation } from 'react-i18next';
import { DeliveryOrderForm } from './DeliveryOrderForm';
import { FormDialogShell } from './FormDialogShell';
import type { IDeliveryOrderDialogProps } from './deliveryOrder.types';
import styles from './DeliveryOrderDialog.module.css';

export type { IDeliveryOrderDialogProps };

/**
 * The modal host for `DeliveryOrderForm` — creates and prefilled "Order now"
 * opens. The form itself (fields, validation, the Delivered-arrival merge)
 * lives in `DeliveryOrderForm` so the delivery drawer's Edit tab can render
 * the identical form inline; all this file owns is the title and which css
 * module skins the shared `FormDialogShell` chrome. Mounted only while open.
 */
export function DeliveryOrderDialog({ onClose, errorMessage, ...form }: IDeliveryOrderDialogProps) {
  const { t } = useTranslation();
  return (
    <FormDialogShell
      onClose={onClose}
      title={t(form.initial ? 'logistics.orderDialog.titleEdit' : 'logistics.orderDialog.titleCreate')}
      cancelLabel={t('logistics.orderDialog.cancel')}
      classes={styles}
      tour="logistics-order-dialog"
    >
      {(cancel) => (
        <>
          {errorMessage ? <p role="alert" className={styles.error}>{errorMessage}</p> : null}
          <DeliveryOrderForm {...form} secondaryAction={cancel} />
        </>
      )}
    </FormDialogShell>
  );
}
